import React, { lazy } from 'react'

import { TAnyType } from '@affstore-ds/types'
import { LoaderApp } from '@affstore-ds/uikit'

const LS_PAGE_WAS_FORCE_REFRESHED = 'page-was-force-refreshed'

// Wrapper component that ignores all props to prevent passing unknown props to DOM elements
// eslint-disable-next-line react-refresh/only-export-components -- Internal wrapper component used only as a fallback during lazy loading retry
const LoaderAppWrapper = () => <LoaderApp id="lazy-load-retry-loader" />

export const lazyLoadPageWithRetry = (componentImport: () => Promise<TAnyType>) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(window.localStorage.getItem(LS_PAGE_WAS_FORCE_REFRESHED) || 'false')

    try {
      const component = await componentImport()

      window.localStorage.setItem(LS_PAGE_WAS_FORCE_REFRESHED, 'false')

      return component
    } catch (error) {
      console.info('[lazyLoadPageWithRetry] Failed to load component:', error)

      if (!pageHasAlreadyBeenForceRefreshed) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.
        console.info('[lazyLoadPageWithRetry] Refreshing page...')
        window.localStorage.setItem(LS_PAGE_WAS_FORCE_REFRESHED, 'true')

        window.location.reload()

        return { default: LoaderAppWrapper }
      }

      // The page has already been reloaded
      // Assuming that user is already using the latest version of the application.
      // Let's let the application crash and raise the error.
      console.info('[lazyLoadPageWithRetry] Already refreshed once, throwing error')
      throw error
    }
  })
